import React from 'react'
import { Autocomplete, TextField, Box } from '@mui/material'
import { DP } from '../../views/driverPayTheme'

// Generic searchable dropdown. `options` is an array of items;
// `getLabel(item)` returns the display label, `getSubLabel` (optional)
// returns a small line under it. `getValue` returns the id used by the
// caller. The selected value's id is reported via onChange(id).
// `appearance`: omit for the original look (super admin pages); 'ink' for the
// restaurant panel's Per-Driver Pay Override.
export default function EntityPicker({
  options = [],
  value,
  onChange,
  loading,
  label = 'Select',
  placeholder = 'Type to search…',
  getLabel = (o) => o?.name || o?._id || '',
  getSubLabel = () => null,
  disabled,
  appearance,
}) {
  const ink = appearance === 'ink'
  const selected = options.find(o => String(o._id) === String(value)) || null
  return (
    <Autocomplete
      fullWidth
      size="small"
      disabled={disabled}
      loading={loading}
      options={options}
      value={selected}
      onChange={(_, next) => onChange(next ? String(next._id) : '')}
      getOptionLabel={getLabel}
      isOptionEqualToValue={(o, v) => String(o._id) === String(v._id)}
      renderOption={(props, option) => (
        <Box component="li" {...props} key={option._id} sx={ink
          ? { display: 'flex', flexDirection: 'column', alignItems: 'flex-start !important', justifyContent: 'center', gap: '2px', py: '10px !important', px: '14px !important' }
          : { display: 'flex', flexDirection: 'column', alignItems: 'flex-start !important', gap: 0.25 }}>
          <Box sx={ink ? { fontSize: 15, fontWeight: 600, lineHeight: 1.35, color: DP.text } : { fontSize: '0.9rem', fontWeight: 600, color: '#0F172A' }}>
            {getLabel(option)}
          </Box>
          {getSubLabel(option) && (
            <Box sx={ink ? { fontSize: 13, lineHeight: 1.4, color: DP.secondary } : { fontSize: '0.75rem', color: '#64748B' }}>
              {getSubLabel(option)}
            </Box>
          )}
        </Box>
      )}
      renderInput={(params) => (
        <TextField {...params} label={label} placeholder={placeholder} />
      )}
    />
  )
}
